import { render, staticRenderFns } from "./ResourcesDropdown.vue?vue&type=template&id=7fe55d38&scoped=true&"
import script from "./ResourcesDropdown.vue?vue&type=script&lang=js&"
export * from "./ResourcesDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesDropdown.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ResourcesDropdown.vue?vue&type=style&index=1&id=7fe55d38&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe55d38",
  null
  
)

export default component.exports